import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
// import { rootStore } from "@/index";
// import config from "@/configs";
import { message } from "antd";
import { rootStore } from "@/index";
import { clientId } from "@/config.json";

const Request = axios.create({
  timeout: 20000,
  // headers: {}
});

export const requestInterceptor = (config: AxiosRequestConfig) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["token"] = token;
  }
  if (rootStore.session.deviceId) {
    config.headers["device-id"] = rootStore.session.deviceId;
  }
  if (clientId) {
    config.headers["Client-id"] = clientId;
  }
  config.headers["Accept-Language"] = rootStore.locale.isCN ? "zh-CN" : "en";
  return config;
};

Request.interceptors.request.use(requestInterceptor, (error) => Promise.reject(error));

export const responseIntercepter = (res: AxiosResponse) => {
  // console.log(res);

  // common support项目
  if (res.config.url && res.config.url.includes("/api/common")) {
    if ((res && res.status >= 200) || res.status < 300) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  }
  // 外链
  if (res.config.url && res.config.url.includes("/api/bch")) {
    if ((res && res.status >= 200) || res.status < 300) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(res);
    }
  }

  if (res && res.status == 200) {
    if (res.data.code == 0) {
      return Promise.resolve(res);
    } else if (res.data.code == -1) {
      message.error(rootStore.locale.get(res.data.msg));
      return Promise.reject(res);
    } else if (res.data.code == -2) {
      message.error(rootStore.locale.get(res.data.msg));
      localStorage.clear();
      // Toast.info(rootStore.locale.get("MSG_user_failed_to_login_or_expired"), 1500);
      // localStorage.removeItem("token");
      // setTimeout(() => {
      location.href = "/home?redirect=no";
      // }, 100);
    } else if (res.data.code == -3) {
      message.error(rootStore.locale.get(res.data.msg));
    } else if (res.data.code === 75000) {
      message.error(res.data.msg);
      localStorage.clear();
      location.href = "/home?redirect=no";
    } else {
      message.error(res.data.msg);
      return Promise.reject(res);
    }
  }
  if (res && res.status >= 500) {
    message.error("System error");
    return Promise.reject(res);
  }
  if (res && res.status >= 400) {
    return Promise.reject(res);
  }
  return Promise.reject(res);
};

Request.interceptors.response.use(responseIntercepter, (error) => Promise.reject(error));

export default Request;
